let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("ewBjz")).then(() => parcelRequire('96V8y'));